import React from 'react';
import { arrayOf, bool, func, node, number, oneOfType, shape, string, } from 'prop-types';
import ValueContainer from './value-container';
const Menu = (props) => {
    const { children } = props;
    return React.createElement("div", { className: "b-async-select-multi__menu" }, children);
};
const Blanket = (props) => {
    const { onClick } = props;
    return React.createElement("div", { tabIndex: 0, onClick: onClick });
};
const Dropdown = (props) => {
    const { children, disabled, isOpen, onDropdownClose, onRemoveValue, placeholder, toggleOpen, values, } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(ValueContainer, { disabled: disabled, isOpen: isOpen, onRemoveValue: onRemoveValue, placeholder: placeholder, toggleOpen: toggleOpen, values: values }),
        isOpen && !disabled && React.createElement(Menu, null, children),
        isOpen && !disabled && React.createElement(Blanket, { onClick: onDropdownClose })));
};
Menu.propTypes = {
    children: node,
};
Menu.defaultProps = {
    children: React.createElement(React.Fragment, null),
};
Blanket.propTypes = {
    onClick: func.isRequired,
};
Dropdown.propTypes = {
    children: node,
    disabled: bool,
    isOpen: bool,
    onDropdownClose: func.isRequired,
    onRemoveValue: func.isRequired,
    placeholder: string,
    toggleOpen: func.isRequired,
    values: arrayOf(shape({ label: string, value: oneOfType([string, number]) })),
};
Dropdown.defaultProps = {
    children: React.createElement(React.Fragment, null),
    disabled: false,
    isOpen: false,
    placeholder: 'Select Option',
    values: [],
};
export default Dropdown;
